(function(){
  var C = window.HPSUB || {};
  var allowed = (C.allowed || []).map(String);
  var first = Number(C.first || 0), rec = Number(C.rec || 0);
  function fmt(n){ return n.toLocaleString('nb-NO', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' kr'; }
  function num(s){
    s = String(s || '').replace(/[^\d.,]/g, '');
    var m = s.match(/^(.*?)[.,](\d{1,2})$/);
    return m ? parseFloat(m[1].replace(/\D/g, '') + '.' + m[2]) : (parseFloat(s.replace(/\D/g, '')) || 0);
  }

  // Husk valget når kunden bytter variant (hver variant har sin egen widget).
  var state = { on: false, idx: null };

  function enhance(block){
    if (block.dataset.hpsub) return;
    var card = block.querySelector('.toggle_card');
    var panel = block.querySelector('.subscribe_panel');
    if (!card || !panel) return;
    block.dataset.hpsub = '1';
    var tabRadios = card.querySelectorAll(':scope > input.tab_radio');
    var subRadio = tabRadios[1];
    var labels = card.querySelectorAll('.tab_label');
    var plans = [].slice.call(block.querySelectorAll('input[data-selling-plan-id]'));
    var mine = allowed.length ? plans.filter(function(i){ return allowed.indexOf(i.dataset.sellingPlanId) > -1; }) : plans;
    if (!mine.length) mine = plans;
    plans.forEach(function(i){ if (mine.indexOf(i) < 0) { var li = i.closest('li'); if (li) li.hidden = true; } });
    block.classList.add('hpsub-ready');

    // Fanetekster
    if (labels[0]) { labels[0].querySelector('span').textContent = 'Engangskjøp'; var op = labels[0].querySelector('.price'); if (op) op.textContent = op.textContent.replace(/\s*NOK/, ' kr'); }
    if (labels[1]) {
      labels[1].querySelector('span').textContent = 'Fast levering';
      if (first || rec) {
        var b = document.createElement('span'); b.className = 'hpsub-pill';
        b.setAttribute('data-t', 'Spar ' + (first || rec) + ' %'); b.setAttribute('aria-hidden', 'true'); labels[1].appendChild(b);
      }
      var sub = document.createElement('span'); sub.className = 'hpsub-sub';
      sub.textContent = 'Ingen binding'; labels[1].appendChild(sub);
    }

    // Frekvens som nedtrekksmeny
    var wrap = document.createElement('div'); wrap.className = 'hpsub-freq';
    var sid = 'hpsub-' + Math.random().toString(36).slice(2,8);
    wrap.innerHTML = '<label for="' + sid + '">Hvor ofte vil du ha levering?</label>';
    var sel = document.createElement('select'); sel.className = 'hpsub-select'; sel.id = sid;
    mine.forEach(function(i, n){
      var t = (i.closest('label').querySelector('.selling_plan_and_price_wrapper > span') || {}).textContent || ('Plan ' + (n+1));
      var o = document.createElement('option'); o.value = n; o.textContent = t.replace(/\s+/g,' ').replace(/,\s*\d+([.,]\d+)?\s*%.*$/,'').trim(); sel.appendChild(o);
    });
    wrap.appendChild(sel);

    // Fordeler
    var ul = document.createElement('ul'); ul.className = 'hpsub-list';
    var items = [];
    if (first && rec && first !== rec) items.push('<strong>' + first + ' % rabatt på første levering</strong>, deretter ' + rec + ' % hver gang');
    else if (rec) items.push('<strong>' + rec + ' % rabatt på hver levering</strong>, hver gang');
    items.push('<strong>Ingen binding.</strong> Fornyes automatisk til du avslutter, uten oppsigelsestid');
    items.push('<strong>Du har kontrollen:</strong> hopp over, sett på pause eller avslutt selv på Min side');
    items.push('<strong>Aldri tomt i skapet.</strong> Leveres automatisk, du slipper å huske å bestille');
    ul.innerHTML = items.map(function(x){ return '<li><span>' + x + '</span></li>'; }).join('');
    panel.insertBefore(wrap, panel.firstChild);
    panel.appendChild(ul);

    // Hint under engangskjøp
    if (first || rec) {
      var hint = document.createElement('p'); hint.className = 'hpsub-otp-hint';
      hint.innerHTML = 'Spar ' + (first || rec) + ' % med <button type="button">fast levering</button>. Ingen binding, og du kan hoppe over eller avslutte når du vil.';
      hint.querySelector('button').addEventListener('click', function(){ if (labels[1]) labels[1].click(); });
      card.insertAdjacentElement('afterend', hint);
    }

    var userPicked = false;
    function isOn(){ return !!block.querySelector('input[data-selling-plan-id]:checked'); }
    function pickDefault(){
      var cur = mine.filter(function(i){ return i.checked; })[0];
      if (!cur || (!userPicked && cur === mine[0])) {
        cur = mine.filter(function(i){ return /hver måned/i.test(i.closest('label').textContent); })[0] || mine[0];
        cur.click();
      }
      sel.value = mine.indexOf(cur);
    }
    function priceTab(){
      var cur = mine.filter(function(i){ return i.checked; })[0] || mine[0];
      var p = labels[1] && labels[1].querySelector('.price');
      var cmp = num(cur.dataset.variantCompareAtPrice);
      if (p && cur.dataset.variantPrice) p.textContent = fmt(num(cur.dataset.variantPrice));
      var c = labels[1] && labels[1].querySelector('.tab_price_compare');
      if (c && cmp) c.textContent = fmt(cmp);
    }
    function atc(){
      var scope = block.closest('.shopify-section') || document;
      var on = isOn();
      block.classList.toggle('hpsub-on', on);
      if (block.offsetParent) state.on = on;
      scope.querySelectorAll('.product-form__submit .btn-text > span:first-child').forEach(function(s){
        if (!s.dataset.hpOrig) s.dataset.hpOrig = s.textContent;
        s.textContent = on ? 'Start fast levering' : s.dataset.hpOrig;
      });
    }
    sel.addEventListener('change', function(){ userPicked = true; state.idx = sel.value; var i = mine[sel.value]; if (i) { i.click(); priceTab(); } });
    block.addEventListener('change', function(e){
      if (e.target === subRadio && subRadio.checked) setTimeout(function(){ pickDefault(); priceTab(); atc(); }, 0);
      setTimeout(atc, 50);
      if (e.target.dataset && e.target.dataset.sellingPlanId) { var k = mine.indexOf(e.target); if (k > -1) sel.value = k; }
      priceTab(); atc();
    });
    block._hpSync = function(){
      if (!state.on || isOn() || !labels[1]) return;
      labels[1].click();
      setTimeout(function(){
        if (state.idx !== null && mine[state.idx]) { userPicked = true; sel.value = state.idx; mine[state.idx].click(); }
        else pickDefault();
        priceTab(); atc();
      }, 30);
    };
    if (isOn()) pickDefault();
    priceTab(); atc();
  }
  function run(){ document.querySelectorAll('section.shopify_subscriptions_app_block').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  function syncVisible(){
    var v = [].filter.call(document.querySelectorAll('section.shopify_subscriptions_app_block'), function(b){ return b.offsetParent && b._hpSync; });
    v.forEach(function(b){ b._hpSync(); });
  }
  document.addEventListener('change', function(e){
    if (e.target.closest && e.target.closest('.shopify_subscriptions_app_block')) return;
    setTimeout(syncVisible, 150);
  });
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(run, 150); }).observe(document.documentElement, {childList:true, subtree:true});
})();
